import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Form, Input, Select, Switch } from "antd";
import CustomModal from "../../../components/Common/CustomModal";
import CommonSelectLite from "components/Common/CommonSelectLite";

interface AddEditSupplierModalProps {
  isOpen: boolean;
  onClose: () => void;
  supplierData: any;
  onSave: (data: any) => void;
  expenseCategories: Array<{ id: string; name: string }>;
}

const AddEditSupplierModal = ({
  isOpen,
  onClose,
  supplierData,
  onSave,
  expenseCategories,
}: AddEditSupplierModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await onSave(values);
      onClose();
      form.resetFields();
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (supplierData) {
      form.setFieldsValue(supplierData);
    } else {
      form.resetFields();
    }
  }, [supplierData]);


  return (
    <CustomModal
      title={supplierData?.id ? t("edit_supplier") : t("add_supplier")}
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      loading={loading}
      saveText={supplierData?.id ? t("save") : t("add")}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          label={t("name")}
          name="name"
          rules={[
            { required: true, message: t("validation.please_enter_name") },
          ]}
        >
          <Input placeholder={t("name")} />
        </Form.Item>

        <Form.Item
          label={t("email")}
          name="email"
          rules={[
            { required: true, message: t("validation.please_enter_email") },
            {
              type: "email",
              message: t("validation.please_enter_valid_email"),
            },
          ]}
        >
          <Input placeholder={t("email")} />
        </Form.Item>

        <Form.Item
          label={t("phone")}
          name="phone"
          rules={[
            { required: true, message: t("validation.please_enter_phone") },
          ]}
        >
          <Input placeholder={t("phone")} />
        </Form.Item>

        <Form.Item label={t("address")} name="address" rules={[
          { required: true, message: t("validation.please_enter_address") },
        ]}>
          <Input.TextArea placeholder={t("address")} rows={3} />
        </Form.Item>

        <Form.Item label={t("tax_number")} name="taxNumber">
          <Input placeholder={t("tax_number")} />
        </Form.Item>

        {/* <Form.Item
          label={t("is_active")}
          name="isActive"
          valuePropName="checked"
        >
          <Switch disabled={!supplierData?.id} />
        </Form.Item> */}

        <Form.Item
          label={t("expense_category")}
          name="ExpenseCategoryId"
          rules={[
            {
              required: true,
              message: t("validation.please_select_expense_category"),
            },
          ]}
        >
          <CommonSelectLite
            options={expenseCategories}
            placeholder={t("select_category")}
            optionValueKey="id"
            optionLabelKey="name"
          />
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default AddEditSupplierModal;
